import { produce } from 'immer';

import { DuplicateInternalBannerImage } from '../../../actions/imageEditor/internal/duplicateInternalBannerImage';
import { getEmptyBannerImage } from '../../../service/BannerHelpers/BannerHelpers';
import { getImageEditorIdByBannerId } from '../../../service/ImageHelpers/ImageHelpers';
import { ImageEditorsState } from '../../../typings/state';

export function duplicateInternalBannerImage(
    state: ImageEditorsState,
    action: DuplicateInternalBannerImage
): ImageEditorsState {
    const id = getImageEditorIdByBannerId(action.bannerId, action.resourceId);
    const newId = getImageEditorIdByBannerId(action.newBannerId, action.resourceId);

    return produce(state, draft => {
        if (!draft[newId]) {
            const image = draft[id];

            draft[newId] = {
                image: !image
                    ? getEmptyBannerImage()
                    : {
                          ...image.image
                      },
                isImageCanvasOpen: false,
                imageGallery: {
                    images: undefined,
                    isImageGalleryOpen: false,
                    selectedImageHashFromGallery: []
                },
                imageUploadingLink: ''
            };
        }
    });
}
